// removed by extract-text-webpack-plugin
module.exports = {"timer-container":"Timer-module-timer-container-2ca52dfcbbd68f9a6b02b9a5e29a48ed--","timer-content":"Timer-module-timer-content-8a2c560c683fab838d58f4f5da10abff--","bigtext":"Timer-module-bigtext-752459425659f18f5942192526437348--","smalltext":"Timer-module-smalltext-6d6ab6f96b75843e698ffe3e640c1613--","minute":"Timer-module-minute-3bf1621541b6dc7d1421a24be8caf3ca--","second":"Timer-module-second-e81323abede274465fc9284d2b81d1f0--","divider":"Timer-module-divider-fff821b68c3987066450bf8ac3339446--"};


//////////////////
// WEBPACK FOOTER
// /src/components/header/timer/Timer.module.scss
// module id = 1644
// module chunks = 0